import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { TextField, Theme, makeStyles } from "@material-ui/core";
import {
	FilterDateWrap,
	TransactionHisFilterDateMuiPickersUtilsProvider,
	TransactionHisFilterDateMuiPickersUtilsProviderImg,
	TransactionHisFilterDateRangeInput,
	TransactionHisFilterDateRangeInputOrder,
	TransactionHisFilterTimeRangeInput,
} from "./StyledDateRangeInput";

export default function DateRangeInput(props: {
	fromDate: Date | null;
	onDateFromChange: (date: Date | null) => void;
	minDate?: Date;
}) {
	const today = new Date();
	return (
		<TransactionHisFilterDateMuiPickersUtilsProvider utils={DateFnsUtils}>
			<TransactionHisFilterDateRangeInput
				disableToolbar
				variant="inline"
				format="yyyy-MM-dd"
				margin="normal"
				value={props.fromDate}
				onChange={props.onDateFromChange}
				placeholder="Chọn ngày"
				minDate={props.minDate || today}
				KeyboardButtonProps={{
					"aria-label": "change date",
				}}
			/>
		</TransactionHisFilterDateMuiPickersUtilsProvider>
	);
}

export function TimeRangeInput(props: { fromTime: Date | null; onTimeFromChange: (time: Date | null) => void }) {
	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<TransactionHisFilterTimeRangeInput
				//   disableToolbar
				//   variant="inline"
				id="time-picker"
				//   format="HH:mm"
				ampm={false}
				margin="normal"
				value={props.fromTime}
				onChange={props.onTimeFromChange}
				placeholder="Chọn giờ"
				KeyboardButtonProps={{
					"aria-label": "change time",
				}}
				keyboardIcon={<TransactionHisFilterDateMuiPickersUtilsProviderImg src="./static/img/time.png" />}
			/>
		</MuiPickersUtilsProvider>
	);
}
